export default __webpack_public_path__ + "static/media/wb_grid_delete_button.2bf5e5ac.svg";